export interface ResolvablePromise<T> extends Promise<T> {
    value: T | undefined;
    error: unknown;
    status: "open" | "failed" | "success";
    resolve(value: T): void;
    reject(reason: any): void; // eslint-disable-line @typescript-eslint/no-explicit-any
}
export default function resolvablePromise<T>(): ResolvablePromise<T> {
    const b = {
        resolve: null! as (v: T) => void,
        //eslint-disable-next-line @typescript-eslint/no-explicit-any
        reject: null! as (r: any) => void,
    };
    const a = new Promise((resolve, reject) => {
        b.resolve = resolve;
        b.reject = reject;
    }) as ResolvablePromise<T>;
    a.resolve = b.resolve;
    a.reject = b.reject;
    a.status = "open";
    a.then(
        c => {
            a.value = c;
            a.status = "success";
        },
        e => {
            a.error = e;
            a.status = "failed";
        },
    );
    return a;
}
